import { SHOW_NOTIFICATION, HIDE_NOTIFICATION } from '@/state/types/notification'

export const showNotification = (
  id,
  text: '',
  data = { timeout: 3000, type: 'info', button: {} },
) => ({
  type: SHOW_NOTIFICATION,
  payload: { id, text, data },
})

export const hideNotification = id => ({
  type: HIDE_NOTIFICATION,
  payload: { id },
})



// WEBPACK FOOTER //
// ./state/actions/notification.js